var _circle, _path, _path2, _path3, _path4, _circle2, _path5, _path6, _path7, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoaderError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 161,
    viewBox: "0 0 151 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 141.875,
    cy: 136.875,
    r: 6.87501,
    fill: "#D95A3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.37244 53.4625C1.95656 54.323 1.47144 56.2288 2.2889 57.7192C3.10636 59.2096 4.91685 59.7203 6.33274 58.8598C7.74863 57.9993 8.23375 56.0935 7.41628 54.6031C6.59882 53.1127 4.78833 52.602 3.37244 53.4625ZM3.07642 52.9228C1.37735 53.9554 0.795207 56.2423 1.77616 58.0308C2.75712 59.8193 4.92971 60.4321 6.62877 59.3995C8.32784 58.3669 8.90998 56.08 7.92902 54.2915C6.94807 52.503 4.77548 51.8902 3.07642 52.9228Z",
    fill: "#D95A3A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.372 10.4094C121.957 11.2699 121.471 13.1756 122.289 14.666C123.106 16.1565 124.917 16.6671 126.333 15.8066C127.749 14.9461 128.234 13.0404 127.416 11.5499C126.599 10.0595 124.788 9.54888 123.372 10.4094ZM123.076 9.86965C121.377 10.9022 120.795 13.1892 121.776 14.9777C122.757 16.7662 124.93 17.3789 126.629 16.3463C128.328 15.3138 128.91 13.0268 127.929 11.2383C126.948 9.44984 124.775 8.83706 123.076 9.86965Z",
    fill: "#D95A3A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.123 152.409C127.707 153.27 127.222 155.176 128.039 156.666C128.857 158.156 130.667 158.667 132.083 157.807C133.499 156.946 133.984 155.04 133.167 153.55C132.349 152.059 130.539 151.549 129.123 152.409ZM128.827 151.87C127.128 152.902 126.546 155.189 127.527 156.978C128.508 158.766 130.68 159.379 132.379 158.346C134.078 157.314 134.66 155.027 133.68 153.238C132.699 151.45 130.526 150.837 128.827 151.87Z",
    fill: "#D95A3A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 43.5833C16.412 43.5833 19.5834 40.412 19.5834 36.5C19.5834 32.588 16.412 29.4167 12.5 29.4167C8.58799 29.4167 5.41667 32.588 5.41667 36.5C5.41667 40.412 8.58799 43.5833 12.5 43.5833ZM12.5 45C17.1944 45 21 41.1944 21 36.5C21 31.8056 17.1944 28 12.5 28C7.80559 28 4 31.8056 4 36.5C4 41.1944 7.80559 45 12.5 45Z",
    fill: "#D95A3A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.0006,
    cy: 75.5002,
    r: 68.0001,
    stroke: "#363853",
    strokeWidth: 2.4,
    strokeLinecap: "round",
    strokeDasharray: "4.8 8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 135.5C32.5 137.985 30.4853 140 28 140C25.5147 140 23.5 137.985 23.5 135.5C23.5 133.015 25.5147 131 28 131C30.4853 131 32.5 133.015 32.5 135.5Z",
    fill: "#D95A3A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.25 4.50001C125.25 6.98529 123.236 9.00002 120.75 9.00002C118.265 9.00002 116.25 6.98529 116.25 4.50001C116.25 2.01472 118.265 0 120.75 0C123.236 0 125.25 2.01472 125.25 4.50001Z",
    fill: "#D95A3A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7504 118C103.946 118 122.75 99.196 122.75 76C122.75 52.804 103.946 34 80.7504 34C57.5545 34 38.7504 52.804 38.7504 76C38.7504 99.196 57.5545 118 80.7504 118Z",
    fill: "#D95A3A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_925_3521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.7504 72.5976L92.6614 60.6866L96.0638 64.0891L84.1529 76L96.0638 87.911L92.6614 91.3134L80.7504 79.4025L68.8395 91.3134L65.437 87.911L77.348 76L65.437 64.0891L68.8395 60.6866L80.7504 72.5976Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_925_3521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.75,
    height: 57.75,
    fill: "white",
    transform: "translate(51.8754 47.125)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderError);
export default __webpack_public_path__ + "static/media/loaderError.b1bdbde0d6f816c33705dd5a22c5bada.svg";
export { ForwardRef as ReactComponent };